module.exports = __webpack_public_path__ + "static/media/requena.6612909b.webp";